import {v4 as uuidv4} from 'uuid';

export class Category {
  id: string;
  is_removed: boolean;
  is_in_summary: boolean;
  constructor(public name: string) {
    this.id = uuidv4();
    this.name = name;
    this.is_removed = false;
    this.is_in_summary = true;
  }
}

/** id is the 3-letter ISO 4217 code (e.g. USD, EUR). */
export class Currency {
  constructor(
    public id: string,
    public name: string,
    public sign: string
  ) {}
}


export class Expense {
  id: string;
  created: number;
  constructor(
    public currency_id: string,
    public value: number,
    public category_id: string
  ) {
    this.id = uuidv4();
    this.currency_id = currency_id;
    this.value = value;
    this.category_id = category_id;
    this.created = new Date().getTime();
  }
}

export type ExpenseDTO = {
  id: string;
  created: number;
  currency: Currency,
  value: number,
  category: Category
}

export interface ExchangeRate {
  id: string;
  from_currency_id: string;
  to_currency_id: string;
  rate: number;
  updated: number;
}

export type Settings = {
  last_currency_id: string | undefined;
  default_currency_id?: string;
}